import _ from 'underscore';

function extract(formattedEstimationOp) {
  const adGroups = _.map(
    formattedEstimationOp.data.CampaignTrafficEstimate.AdGroupTrafficEstimateParameters,
    (adGroup) => {
      return {
        Keywords: adGroup.KeywordTrafficEstimateParameters,
        Bid: adGroup.MaxCPC,
      };
    },
  );
  const adGroupsWithoutBid = _.map(
    formattedEstimationOp.data.CampaignTrafficEstimate.AdGroupTrafficEstimateParameters,
    (adGroup) => {
      return {
        Keywords: adGroup.KeywordTrafficEstimateParameters,
      };
    },
  );
  const targetings = formattedEstimationOp.data.CampaignTrafficEstimate.Targetings;
  const locationIds = _
    .chain(targetings)
    .map((targeting) => targeting.LocationId)
    .compact()
    .value();
  const languages = _
    .chain(targetings)
    .map((targeting) => targeting.Language)
    .compact()
    .value();

  return {
    adGroups,
    locationIds,
    languages,
    adGroupsWithoutBid,
  };
}

export function budgetSuggestionOpFormatter(formattedEstimationOp, params) {
  const extractedOp = extract(formattedEstimationOp);

  return {
    data: {
      Request: {
        Campaigns: [{
          AdGroups: extractedOp.adGroups,
          CurrentBudget: params.budget,
          InitialBudget: params.initBudget,
          Languages: extractedOp.languages,
          LocationIds: extractedOp.locationIds,
        }],
      },
    },
    path: formattedEstimationOp.path,
  };
}

export function bidSuggestionOpFormatter(formattedEstimationOp) {
  const extractedOp = extract(formattedEstimationOp);

  return {
    data: {
      Request: {
        AdGroups: extractedOp.adGroupsWithoutBid,
        Languages: extractedOp.languages,
        LocationIds: extractedOp.locationIds,
      },
    },
    path: formattedEstimationOp.path,
  };
}
